import { Icon } from '@iconify/react';
import cloud from '../assets/img/data_center_monochromatic.png';
import backend from '../assets/img/data_process_monochromatic.png';
import frontend from '../assets/img/online_store.png';
import movil from '../assets/img/user_group_two_color.png';
import Header from '../components/layout/Header';
import AnimatedSection from '../components/ui/AnimatedSection';
import Carousel from '../components/ui/Carousel';

const problemas = [
  { icon: 'mdi:progress-wrench', label: 'Mucho trabajo manual' },
  { icon: 'mdi:file-excel', label: 'Excel por todos lados' },
  { icon: 'mdi:chat-alert', label: 'Ventas por WhatsApp sin control' },
  { icon: 'mdi:timer-sand', label: 'Procesos lentos' },
  { icon: 'mdi:file-multiple', label: 'Información duplicada' },
  { icon: 'mdi:chart-bar-off', label: 'Falta de indicadores' },
  { icon: 'mdi:monitor-shimmer', label: 'Sistemas antiguos' },
];

const ofertas = [
  {
    icon: 'mdi:chat-processing',
    titulo: 'Agente IA para WhatsApp',
    items: [
      'Responde clientes 24/7',
      'Consulta stock',
      'Genera cotizaciones',
      'Captura leads',
      'Agenda reuniones',
    ],
    color: '#25D366',
  },
  {
    icon: 'mdi:cart',
    titulo: 'Ecommerce Inteligente',
    items: [
      'Tienda online',
      'Pasarela de pago',
      'Integración logística',
      'Agente IA',
      'Automatización comercial',
    ],
    color: '#f26724',
  },
  {
    icon: 'mdi:database',
    titulo: 'ERP para Pymes',
    items: [
      'Inventario',
      'Ventas',
      'Caja',
      'Reportes',
      'Dashboard',
    ],
    color: '#17a2b8',
  },
];

const solucionesIA = [
  { icon: 'mdi:robot', label: 'Agentes IA' },
  { icon: 'mdi:chat-processing', label: 'Chatbots' },
  { icon: 'mdi:headset', label: 'WhatsApp IA' },
  { icon: 'mdi:file-document', label: 'Automatización documental' },
  { icon: 'mdi:brain', label: 'Procesamiento de documentos' },
  { icon: 'mdi:cloud', label: 'Integraciones OpenAI' },
  { icon: 'mdi:cogs', label: 'Automatización atención al cliente' },
  { icon: 'mdi:chart-line', label: 'Analítica con IA' },
];

const casos = [
  {
    cliente: 'Gethex Perú',
    problema: 'Atención manual por WhatsApp y gestión descentralizada.',
    solucion: 'Plataforma web con catálogo digital y panel administrativo.',
    resultado: 'Atención automatizada y control centralizado de operaciones.',
    link: 'https://www.gethex.com.pe',
  },
  {
    cliente: 'Paket',
    problema: 'Inventario en Excel y procesos logísticos lentos.',
    solucion: 'Sistema de gestión comercial con control de inventario.',
    resultado: 'Reducción de tiempos operativos y control en tiempo real.',
    link: 'https://paket.pe',
  },
  {
    cliente: 'Casa Santivañez',
    problema: 'Sistemas antiguos y falta de indicadores de gestión.',
    solucion: 'ERP personalizado con reportes y dashboard.',
    resultado: 'Información centralizada y toma de decisiones basada en datos.',
    link: 'https://www.infocsantivanez.net/Account/login',
  },
];

const servicios = [
  { img: backend, titulo: 'Backend', desc: 'Infraestructura robusta, segura y escalable para tus aplicaciones.', reverse: false },
  { img: frontend, titulo: 'Frontend', desc: 'Experiencias de usuario modernas, rápidas y responsivas.', reverse: true },
  { img: movil, titulo: 'Móvil', desc: 'Aplicaciones nativas y multiplataforma para iOS y Android.', reverse: false },
  { img: cloud, titulo: 'Cloud', desc: 'Arquitectura en la nube con Azure y AWS para máximo rendimiento.', reverse: true },
];

export default function Home() {
    return(
        <>
        <Header />
        <main className="bg-[#f5f5f7] text-[#2d2d44]">
            {/* Problemas */}
            <AnimatedSection as="section" className="py-20 md:py-28 section-glow-1">
              <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-col items-center gap-4 mb-12">
                  <div className="w-14 h-14 rounded-2xl bg-[#f26724]/10 border border-[#f26724]/20 flex items-center justify-center">
                    <Icon icon="mdi:alert-circle" className="text-3xl text-[#f26724]" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#f26724] text-glow">¿Tu empresa tiene alguno de estos problemas?</h2>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto">
                  {problemas.map((p, i) => (
                    <AnimatedSection key={i} animation="fade-in-up" delay={i * 80} className="flex items-center gap-3 card-gradient-sm border border-black/10 rounded-xl px-4 py-3 hover:border-red-500/30 transition-all group">
                      <div className="w-9 h-9 rounded-lg bg-red-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-red-500/20 transition-colors">
                        <Icon icon={p.icon} className="text-red-400 text-lg" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700 group-hover:text-[#f26724] transition-colors">{p.label}</span>
                    </AnimatedSection>
                  ))}
                </div>
                <div className="text-center mt-8">
                  <p className="text-gray-500 text-lg mb-6">Nosotros resolvemos estos problemas.</p>
                  <a href="https://api.whatsapp.com/send?phone=51946564003&text=Quiero%20resolver%20mis%20problemas%20de%20gesti%C3%B3n" className="inline-flex items-center gap-2 px-8 py-4 bg-[#f26724] text-black font-semibold rounded-xl hover:bg-[#f3823c] transition-all hover:shadow-neon-lg hover:-translate-y-0.5" target="_blank" rel="noopener noreferrer">
                    Quiero resolverlos <Icon icon="mdi:arrow-right" className="text-xl" />
                  </a>
                </div>
              </div>
            </AnimatedSection>

            {/* Ofertas */}
            <AnimatedSection as="section" className="py-20 md:py-28 bg-[#212529] ">
              <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-col items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-2xl bg-[#f26724]/10 border border-[#f26724]/20 flex items-center justify-center">
                    <Icon icon="mdi:package-variant-closed" className="text-3xl text-[#f26724]" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#f26724] text-glow">Soluciones diseñadas para tu negocio</h2>
                </div>
                <p className="text-gray-300 text-center text-lg mb-12">Paquetes listos para implementar en semanas, no meses.</p>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                  {ofertas.map((oferta, i) => (
                    <AnimatedSection key={i} animation="fade-in-up" delay={i * 120} className="group bg-[#ffffff10] border border-black/10 rounded-2xl overflow-hidden hover:border-[#f26724] hover:-translate-y-1 hover:shadow-[0_20px_88px_-35px_#f26724] transition-all duration-300 flex flex-col">
                      <div className="p-6 md:p-8 text-center" style={{borderBottom: `2px solid ${oferta.color}`}}>
                        <Icon icon={oferta.icon} className="text-5xl mb-4 mx-auto" style={{color: oferta.color}} />
                        <h3 className="text-xl font-semibold text-[#ffffff]">{oferta.titulo}</h3>
                      </div>
                      <ul className="p-6 md:p-8 space-y-3 flex-1">
                        {oferta.items.map((item, j) => (
                          <li key={j} className="flex items-center gap-3 text-white">
                            <Icon icon="mdi:check-circle" className="text-lg flex-shrink-0" style={{color: oferta.color}} />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                      <div className="px-6 md:px-8 pb-6 md:pb-8">
                        <a href={"https://api.whatsapp.com/send?phone=51946564003&text=Quiero%20informaci%C3%B3n%20sobre%20" + encodeURIComponent(oferta.titulo)} className="flex items-center justify-center gap-2 w-full px-6 py-3 border-2 border-[#f26724]/50 text-[#f26724] font-semibold rounded-xl hover:bg-[#f26724]/10 hover:border-[#f26724] hover:shadow-neon-sm transition-all" target="_blank" rel="noopener noreferrer">
                          Más información <Icon icon="mdi:arrow-right" />
                        </a>
                      </div>
                    </AnimatedSection>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            {/* IA */}
            <AnimatedSection as="section" className="py-20 md:py-28 section-glow-1">
              <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-col items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-2xl bg-[#f26724]/10 border border-[#f26724]/20 flex items-center justify-center">
                    <Icon icon="mdi:robot" className="text-3xl text-[#f26724]" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#f26724] text-glow">Inteligencia Artificial para Empresas</h2>
                </div>
                <p className="text-gray-500 text-center text-lg mb-12">Potencia tu negocio con tecnología de IA aplicada a resultados reales.</p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
                  {solucionesIA.map((sol, i) => (
                    <AnimatedSection key={i} animation="fade-in-up" delay={i * 80} className="flex flex-col items-center gap-3 card-gradient border border-black/10 rounded-xl py-6 px-4 hover:border-[#f26724]/30 hover:-translate-y-0.5 transition-all">
                      <Icon icon={sol.icon} className="text-3xl text-[#f26724]" />
                      <span className="text-sm text-gray-700 text-center">{sol.label}</span>
                    </AnimatedSection>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            {/* Casos */}
            <AnimatedSection as="section" className="py-20 md:py-28 bg-[#ea6423]">
              <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-col items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-2xl bg-[#ffffff60] border border-[#f26724]/20 flex items-center justify-center">
                    <Icon icon="mdi:briefcase" className="text-3xl text-[#f26724]" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#ffffff] text-glow">Casos de uso reales</h2>
                </div>
                <p className="text-gray-900 text-center text-lg mb-12">Resultados que hablan por sí solos.</p>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                  {casos.map((caso, i) => (
                    <AnimatedSection key={i} animation="fade-in-up" delay={i * 120} className="card-gradient border border-black/10 rounded-2xl p-6 hover:border-[#f26724]/30 hover:-translate-y-0.5 transition-all flex flex-col">
                      <h3 className="text-xl font-semibold text-[#f26724] pb-4 mb-4 border-b border-black/10">{caso.cliente}</h3>
                      <div className="space-y-3 flex-1">
                        <p className="text-sm text-gray-600 leading-relaxed"><span className="text-[#f26724] font-medium">Problema:</span> {caso.problema}</p>
                        <p className="text-sm text-gray-600 leading-relaxed"><span className="text-[#f26724] font-medium">Solución:</span> {caso.solucion}</p>
                        <p className="text-sm text-gray-600 leading-relaxed"><span className="text-[#f26724] font-medium">Resultado:</span> {caso.resultado}</p>
                      </div>
                      <div className="pt-4 mt-4 border-t border-black/10">
                        <a href={caso.link} className="inline-flex items-center gap-2 text-sm text-[#f26724] hover:text-[#f26724] transition-colors" target="_blank" rel="noopener noreferrer">
                          Ver sitio <Icon icon="mdi:arrow-right" />
                        </a>
                      </div>
                    </AnimatedSection>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            {/* Servicios Tradicionales */}
            <AnimatedSection as="section" className="py-20 md:py-28 bg-[#262164]">
              <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-col items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-2xl bg-[#f26724]/6 border border-[#f26724]/20 flex items-center justify-center">
                    <Icon icon="mdi:code-tags" className="text-3xl text-[#f26724]" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#f26724] text-glow">Capacidades de desarrollo</h2>
                </div>
                <p className="text-gray-200 text-center text-lg mb-16">Tecnología robusta y escalable para cada necesidad.</p>
                <div className="max-w-5xl mx-auto space-y-12">
                  {servicios.map((svc, i) => (
                    <AnimatedSection key={i} animation={i % 2 === 0 ? 'fade-in-left' : 'fade-in-right'} delay={i * 100} className={`flex flex-col ${svc.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 md:gap-16`}>
                      <div className="md:w-5/12">
                        <img src={svc.img} className="w-full max-w-sm mx-auto hover:scale-105 transition-transform duration-500" alt={svc.titulo} />
                      </div>
                      <div className="md:w-7/12 text-center md:text-left">
                        <h4 className="text-3xl md:text-4xl font-bold text-[#f26724] mb-4 text-glow">{svc.titulo}</h4>
                        <p className="text-gray-200 leading-relaxed text-xl md:text-2xl">{svc.desc}</p>
                      </div>
                    </AnimatedSection>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            {/* Tecnologías */}
            <AnimatedSection as="section" className="py-20 md:py-28 bg-[#1b1b3a]">
              <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-col items-center gap-4 mb-12">
                  <div className="w-14 h-14 rounded-2xl bg-[#f26724]/10 border border-[#f26724]/20 flex items-center justify-center">
                    <Icon icon="mdi:hexagon-multiple" className="text-3xl text-[#f26724]" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#f26724] text-glow">Tecnologías con las que trabajamos</h2>
                </div>
                <Carousel />
              </div>
            </AnimatedSection>

            {/* CTA */}
            <AnimatedSection as="section" className="py-20 md:py-28 bg-gradient-to-b from-orange-50 to-transparent text-center">
              <div className="max-w-3xl mx-auto px-4">
                <div className="flex flex-col items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-2xl bg-[#f26724]/10 border border-[#f26724]/20 flex items-center justify-center">
                    <Icon icon="mdi:rocket-launch" className="text-3xl text-[#f26724]" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#f26724] text-glow">Descubre cuánto podrías automatizar</h2>
                </div>
                <p className="text-gray-600 text-lg mb-8 leading-relaxed">Agenda una reunión gratuita y te mostramos cómo reducir hasta 80% del trabajo manual en tu empresa.</p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a href="https://api.whatsapp.com/send?phone=51946564003&text=Quiero%20agendar%20una%20reuni%C3%B3n%20gratuita" className="inline-flex items-center gap-2 px-8 py-4 bg-[#f26724] text-black font-semibold rounded-xl hover:bg-[#f3823c] transition-all hover:shadow-neon-lg hover:-translate-y-0.5" target="_blank" rel="noopener noreferrer">
                    <Icon icon="mdi:whatsapp" className="text-xl" /> Agenda una reunión gratuita
                  </a>
                  <a href="mailto:gian.gomez@scalar.pe" className="inline-flex items-center gap-2 px-8 py-4 border-2 border-black/20 text-gray-600 font-semibold rounded-xl hover:bg-black/5 hover:border-black/40 transition-all">
                    <Icon icon="mdi:email" className="text-xl" /> Escríbenos un correo
                  </a>
                </div>
              </div>
            </AnimatedSection>
        </main>
    </>
    )
}
